module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "app",
    attrs: {
      "id": "app"
    }
  }, [(_vm.isPreviewPage) ? _c('div', {
    staticClass: "preview"
  }, [_vm._v("内部链接 请勿分享给机构外部人员使用")]) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e48ea8f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 838
// module chunks = 2